module.exports = __webpack_public_path__ + "wheatPTI.png?f310e767ab6e8d42aa9ac3aca55a8dad";


//////////////////
// WEBPACK FOOTER
// ./src/assets/static/wheatPTI.png
// module id = 226
// module chunks = 0